<div class="video-container">
  @if (consent.granted) {
    <iframe [src]="sanitizedVideoUrl"
      width="380"
      height="240"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
      allowfullscreen
      title="RESPECT Coaching Styles Report Video Walkthrough" >
    </iframe>
  } @else {
    <p>This video is hosted by Vimeo, which may set cookies and collect data about your visit. Accepting also turns on performance monitoring, which may set additional cookies and send data to third parties. You can change your choice at any time from Cookie Settings.</p>
    <button type="button" (click)="consent.grant()">Accept cookies and watch</button>
  }
</div>
